import $ from 'jquery';
import { Drilldown } from 'foundation-sites';

window.addEventListener('load', function(event) {

  // ### DrillDown Menu
  // Settings
  const drillDownEl = $(".js-responsive-menu > ul");
  const drillDownBack = drillDownEl.attr('data-back');
  const $triggersMenu = $('.js-menu-toggle');
  const drillDownOptions = {
    backButton: `<li class="js-drilldown-back"><a tabindex="0">retour</a></li>`,
    closeOnClick: true,
    parentLink: true
    //scrollTop: true,
    //autoHeight: true,
    //animateHeight: true
  };
  // Init
  const drillDownInstance = new Drilldown(drillDownEl, drillDownOptions);

  // ### Toggle Open/Close
  $triggersMenu.on('click', function(ev){
    ev.preventDefault();
    $('body').toggleClass('menu-open');
  });

});
